export default "__VITE_ASSET__10c57eff__"